export class TagModel {
  private readonly _id: string;
  private readonly _name: string;
  private readonly _slug: string;
  private readonly _userCreated: boolean;
  private readonly _partnerId: string | null;

  constructor(
    id: string,
    name: string,
    slug: string,
    userCreated: boolean = false,
    partnerId: string | null = null
  ) {
    this._id = id;
    this._name = name;
    this._slug = slug;
    this._userCreated = userCreated;
    this._partnerId = partnerId;
  }

  public static from(data: TagModel): TagModel {
    return new TagModel(
      data._id,
      data._name,
      data._slug,
      data._userCreated,
      data._partnerId
    );
  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  get slug(): string {
    return this._slug;
  }

  get userCreated(): boolean {
    return this._userCreated;
  }

  get partnerId(): string | null {
    return this._partnerId;
  }
}

export interface CategorizedTags {
  system: TagModel[];
  user: TagModel[];
  general: TagModel[];
  partner: TagModel[];
}
